<template>
  <button
    v-if="!to"
    class="transition duration-300 ease-in-out focus:outline-none text-white text-md py-4 px-10 rounded focus:shadow-focus"
  >
    <font-awesome-icon :icon="icon" class="mr-2" /> {{ text }}
  </button>
  <router-link
    v-else
    :to="to"
    class="transition duration-300 ease-in-out focus:outline-none text-white text-md py-4 px-10 rounded focus:shadow-focus"
  >
    <font-awesome-icon :icon="icon" class="mr-2" /> {{ text }}
  </router-link>
</template>

<script>
export default {
  name: 'ButtonIcon',
  props: {
    icon: String,
    text: String,
    to: Object
  }
}
</script>

<style>
</style>
